import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useAccountApplications} from '../hooks/useAccountApplications';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";

export const ReloadRecordsButton = () => {

    const {userAccount} = useUserAccount()

    if (!userAccount) {
        throw new Error('user account is required parameter')
    }

    const {fetchRecords} = useAccountApplications(userAccount.id);
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};

